import React from 'react';
import { WrappedMessage } from '../../../../../utils';
import messages from '../../../../displayMessages';
import CareerTasks from './CareerTasks';
import { ChallengeCard } from './ChallengeCard';
import { CareerSuggestedAssets, CareerDuty } from 'labxchange-client';
import { Icon } from '../../../../../elements';

interface CareerDutiesProps {
    duty: CareerDuty;
    suggestedAssets?: CareerSuggestedAssets[];
}

const CareerDuties: React.FC<CareerDutiesProps> = ({
  duty,
  suggestedAssets,
}) => {

    return (
       <div className='career-duties'>
           <div>
               <h2> <WrappedMessage message={messages.CareerDutiesHeadingText} /> </h2>
               <div className='career-duties-description'>
                   <WrappedMessage message={messages.CareerDutiesIntroText} />
               </div>
           </div>

           {duty.tasks.length > 0 &&
             <CareerTasks
               tasks={duty.tasks}
               backgroundImage={duty.backgroundImage}
             />
           }

           {duty.insights &&
             <div className='career-duties-insight'>
               <Icon name='info' zoom='1.2em' fill={'#00AEEF'} />
               <div className='insight'>
                   {duty.insights}
               </div>
             </div>
           }

           <div>
               {(suggestedAssets && suggestedAssets.length > 0 )&&
                 <>
                   <div className='divider' data-testid='divider'></div>
                   <h3 className='challenge-heading'>
                     <WrappedMessage message={messages.careerChallengeHeading}/>
                   </h3>
                     {
                         suggestedAssets.map((asset, i) => (
                             <ChallengeCard key={i} suggestedAsset={asset}/>
                         ))
                     }
                 </>
               }
           </div>
       </div>
    );
};

export default CareerDuties;
